import React from 'react'

import { ValidatorForm } from 'react-material-ui-form-validator'

import {
    GridContainer,
    GridItem6sm12xs12,
 } from '../../../business-components/Grid/Grid'

import EstudoFormExclusaoFamiliares from './EstudoFormExclusaoFamiliares'

import EstudoFormExclusaoDespesasGarantias from './EstudoFormExclusaoDespesasGarantias'



const EstudoFormExclusao = ( { values, handleChange, handleSubmit } ) => {

    return (
        <ValidatorForm 
            onSubmit={handleSubmit}
            onError={
                () => null
            }
        >
            <GridContainer>
                <GridItem6sm12xs12>
                    <EstudoFormExclusaoFamiliares
                        values={values}
                        handleChange={handleChange}
                    />
                </GridItem6sm12xs12>

                <GridItem6sm12xs12>
                    <EstudoFormExclusaoDespesasGarantias
                        values={values}
                        handleChange={handleChange}
                    />
                </GridItem6sm12xs12>
            </GridContainer>
        </ValidatorForm>
    )
}

export default EstudoFormExclusao